import {Link, Text} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import {LABELS, VALUES} from '../../constants'
import type {EventActor$key} from './__generated__/EventActor.graphql'
import {GhostActor} from './GhostActor'
import {userHovercardPath} from '@github-ui/paths'

type EventActorProps = {
  actor: EventActor$key | null
}

type EventActorPropsInternal = {
  actor: EventActor$key
}

export function EventActor({actor}: EventActorProps): JSX.Element {
  return actor ? <EventActorInternal actor={actor} /> : <GhostActor />
}

function EventActorInternal({actor}: EventActorPropsInternal): JSX.Element {
  const {login} = useFragment(
    graphql`
      fragment EventActor on Actor {
        login
      }
    `,
    actor,
  )
  if (login === VALUES.ghostUserLogin) {
    return <Text>{LABELS.repositoryOwner} </Text>
  } else if (!actor) {
    return <Text>{VALUES.ghostUserLogin} </Text>
  }

  return (
    <Link
      href={`/${login}`}
      data-hovercard-url={userHovercardPath({owner: login})}
      sx={{
        color: 'fg.default',
        fontWeight: 600,
        mr: 1,
      }}
      muted
    >
      {login}
    </Link>
  )
}

try{ EventActor.displayName ||= 'EventActor' } catch {}
try{ EventActorInternal.displayName ||= 'EventActorInternal' } catch {}